import { ERROR, WARNING } from '../constants';
import { errors } from '../errors';

const LEVELS = {
  [ERROR]: 'error',
  [WARNING]: 'warning',
};

// We pass `captureMessage` in below for testing purposes. The `sentry`
// plugin is the plugin we should normally use.
// eslint-disable-next-line no-underscore-dangle
export function _sentryTrack(captureMessage) {
  return () => (event) => {
    if ([ERROR, WARNING].includes(event.verb)) {
      captureMessage(event.details.message || event.object, {
        extra: event,
        level: LEVELS[event.verb],
        tags: {
          domain: event.domain,
        },
      });
    }
  };
}

/**
 * @memberof module:EventTracker
 *
 * @description
 * Sends errors and warnings to Sentry. This plugin only handles events with
 * verbs `ERROR` and `WARNING`.
 *
 * Usage:
 *
 * ```
 * import { sentry } from '@updater-core/lib/tracker';
 *
 * setPlugins(plugins => [
 *   ...plugins,
 *   sentry()
 * ]);
 * ```
 *
 * @returns {plugin} plugin
 */
export const sentryTrack = _sentryTrack(errors.captureMessage);
